import React, { Component } from "react";
import * as THREE from "three";
import { OrbitControls } from 'three-orbitcontrols-ts' //import { OrbitControls } from 'three-orbitcontrols-ts'
import Hud from "./hud";
import Message from './Message';


export default class LayerThree extends Component {

    constructor(props) {    super(props);    this.state = {      score:0, vie:3,message:"press p to start",display:"block",display2:"none"   };  };
    
    me1 = "press p to start";
    me2 = "u loose press r to restart"
    mouse = new THREE.Vector2();
    scene = new THREE.Scene();
    element = new Array();
    Spherecolor = ["#ED2020", "#DDED20", "#20ED29", "#2920ED", "#E420ED"]; //contient les couleurs de boules possibles
    level = 0;
    diff = 1;
    party = false; // pour mettre en pause

    onKeyDown = (event) => {  //la fonction appeller pour mettre en pause en cas d'appuie sur une touche
        var kc = event.keyCode;

        if (kc === 80) {
            if (this.party) {
                this.party = false;
            }
            else {
                this.party = true;
            }
            if(this.state.display === "block"){
                this.setState({display:"none"});
            }
        }
        if (kc === 82) {
            if (!this.party) {
                this.restart();
            }
        }
    }


    onMouseMove = (event) => {
        // calculate mouse position in normalized device coordinates
        // (-1 to +1) for both components
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

    }

    intersect(sphere, other) { //calcule l'intersection entre deux spheres
        // we are using multiplications because it's faster than calling Math.pow
        var distance = Math.sqrt((sphere.position.x - other.position.x) * (sphere.position.x - other.position.x) +
            (sphere.position.y - other.position.y) * (sphere.position.y - other.position.y) +
            (sphere.position.z - other.position.z) * (sphere.position.z - other.position.z));
        return distance < (sphere.geometry.parameters.radius + other.geometry.parameters.radius);
    }

    updateLevel() { // tout les dix niveau la difficulté augmente
        this.level = this.level + 1;
        if (this.level % 10 === 0) {
            this.diff++;
        }
    }

    createSun() { //creer un seul et unique solil 
        var geometry = new THREE.SphereGeometry(2, 32, 16);
        var material = new THREE.MeshPhongMaterial({ color: 0xff00ff });
        var sphere = new THREE.Mesh(geometry, material);
        this.scene.add(sphere);
        sphere.name = 'sun';
        sphere.material.color.set(this.Spherecolor[1]);
        return sphere;
    }

    createSphere(taille, vec, idColor) { //creer une sphere pour une taille une position et une color donnée 
        var geometry = new THREE.SphereGeometry(taille, 32, 16);
        var material = new THREE.MeshPhongMaterial({ color: 0xffff00 });
        var sphere = new THREE.Mesh(geometry, material);
        this.scene.add(sphere);
        sphere.material.color.set(this.Spherecolor[idColor]);
        sphere.translateX(vec.x);
        sphere.translateY(vec.y);
        sphere.translateZ(vec.z);
        this.element.push(sphere); // on l'ajoute au tableau des spheres 
    }

    createLight(inten, x, y, z) { // on ajoute deux lumieres une ambiantes et une directionnel 
        const color = 0xFFFFFF;
        const intensity = inten;
        const light = new THREE.DirectionalLight(color, intensity);
        light.position.set(x, y, z);
        this.scene.add(light);
        const ambientLight = new THREE.AmbientLight(0x222222);
        this.scene.add(ambientLight);
    }

    moveToCenter(sphere) {  // pour de la 2D et la quantité de mouvement n'est pas fixe 
        if (sphere.position.x < 0) {
            sphere.translateX(0.1);
        }
        else {
            sphere.translateX(-0.1);
        }
        if (sphere.position.y < 0) {
            sphere.translateY(0.1);
        }
        else {
            sphere.translateY(-0.1);
        }
    }

    moveToCenter2(sphere) { //deplace une sphere en direction du centre 
        var A = new THREE.Vector3(sphere.position.x, sphere.position.y, sphere.position.z); // start
        var B = new THREE.Vector3(0, 0, 0); // end
        var C = new THREE.Vector3().subVectors(B, A).setLength(0.2).add(A);
        sphere.position.x = C.x;
        sphere.position.y = C.y;
        sphere.position.z = C.z;
    }

    sameColor(sun, sphere) { // renvoie true si la valeur des couleur des deux objets sont les memes 
        if (sun.material.color.r * 255 === sphere.material.color.r * 255 && sun.material.color.g * 255 === sphere.material.color.g * 255 && sun.material.color.b * 255 === sphere.material.color.b * 255) {
            return true;
        }
        else {
            return false;
        }
    }

    changeColor(sphere) { //change la couleur d'une sphere 
        if (sphere.material.color.r * 255 === 237 && sphere.material.color.g * 255 === 32 & sphere.material.color.b * 255 === 32) {
            sphere.material.color.set(this.Spherecolor[1])
        }
        else if (sphere.material.color.r * 255 === 221 && sphere.material.color.g * 255 === 237 & sphere.material.color.b * 255 === 32) {
            sphere.material.color.set(this.Spherecolor[2])
        }
        else if (sphere.material.color.r * 255 === 32 && sphere.material.color.g * 255 === 237 & sphere.material.color.b * 255 === 41) {
            sphere.material.color.set(this.Spherecolor[3])
        }
        else if (sphere.material.color.r * 255 === 41 && sphere.material.color.g * 255 === 32 & sphere.material.color.b * 255 === 237) {
            sphere.material.color.set(this.Spherecolor[4])
        }
        else if (sphere.material.color.r * 255 === 228 && sphere.material.color.g * 255 === 32 & sphere.material.color.b * 255 === 237) {
            sphere.material.color.set(this.Spherecolor[0])
        }
        else {
            sphere.material.color.set(this.Spherecolor[0]);
        }
    }

    changeSunColor(sun) { //change la souleur du soleil 
        var random = Math.floor(Math.random() * (4 - 0 + 1)) + 0;
        sun.material.color.set(this.Spherecolor[random]);
    }

    generatePointAroudCircle(radius) { //creer des points aleatoires a la periphérie d'un cercle 2d
        var angle = Math.random() * Math.PI * 2;
        var x = Math.cos(angle) * radius;
        var y = Math.sin(angle) * radius;
        return (new THREE.Vector3(x, y, 0));
    }

    generatePointAroundSphere(r) { // creer des points aleatoires a la peripherie d'une sphere 3D
        var s = Math.random() * Math.PI * 2;
        var t = Math.random() * Math.PI * 2;
        var x = r * Math.cos(s) * Math.sin(t)
        var y = r * Math.sin(s) * Math.sin(t)
        var z = r * Math.cos(t)
        return (new THREE.Vector3(x, y, z));
    }

    generateFromLevel() { // definis en fonction du nombre de difficulté le nombre de sphere a creer 
        for (let i = 0; i < this.diff; i++) {
            var random = Math.floor(Math.random() * (4 - 0 + 1)) + 0;
            var randomRad = Math.floor(Math.random() * (45 - 30 + 1)) + 30;
            this.createSphere(2, this.generatePointAroundSphere(randomRad), random);
        }
    }

    restart(){
        for (let i = 0; i < this.element.length; i++) {
            this.scene.remove(this.element[i]);
        }
        this.element = [];
        this.level = 0;
        this.diff = 1;
        this.setState({score:0,vie:3,message:this.me1,display:"block",display2:"none"});
        this.createSphere(2, new THREE.Vector3(38, 0, 0),3)
    }


    componentDidMount() { //s'active au moment ou le composant est monter 

        document.addEventListener('keydown', this.onKeyDown); //sur le doc car cela ne marche pas bien sur le composant 
        this.mount.setAttribute("tabindex", 0); //permet d'eviter un bug au niveau du raycaster 
        this.mount.addEventListener('mousemove', this.onMouseMove); // permet d'utiliser le raycaster 

        const camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer();
        renderer.setSize(window.innerWidth, window.innerHeight);
        this.mount.appendChild(renderer.domElement);
        camera.position.z = 60;

        var controls = new OrbitControls(camera, renderer.domElement); //orbit controller pour rotationner en 3d avec la curseur 
        controls.enableDamping = true; 
        controls.dampingFactor = 0.05;
        controls.screenSpacePanning = false;
        controls.minDistance = 100;
        controls.maxDistance = 500;
        controls.maxPolarAngle = Math.PI / 2;


        const raycaster = new THREE.Raycaster(); //permet de verifier si un objets et dans la ligne de notre curseur par rapport a la camera 
        raycaster.setFromCamera(this.mouse, camera);
        var intersects = raycaster.intersectObjects(this.scene.children);

        this.createLight(1, -5, 2, 20);
        var sun = this.createSun(); //on vas reutiliser le sun donc on le stock 
        this.createSphere(2, new THREE.Vector3(38, 0, 0),3); // il nous faut une sphere de depart 
        var vide = true; // pour eviter que l'on change de couleur a la vitesse de la lumiere au passage du curseur 


        const animate = () => {
            requestAnimationFrame(animate);
            if (this.party) { // pour la pause 
                var element = this.element; // probleme etrange d'assignement que l'on regle ici 
                console.log(element);
                for (let i = 0; i < element.length; i++) { // on verifie les intéractions 
                    this.moveToCenter2(element[i]);
                    if (this.intersect(sun, element[i])) {
                        if (this.sameColor(sun, element[i])) {
                            this.updateLevel();
                            this.setState({score:this.state.score+1});
                        }
                        else {
                            this.setState({vie:this.state.vie-1});
                            if(this.state.vie === 0){
                                this.party = false;
                                this.setState({message:this.me2 ,display:"block",display2:"block"})
                            }
                        }
                        this.scene.remove(element[i]); //retire de la scene la variable 
                        this.element.splice(i, 1); //retire et reindex le tableau 
                    }
                }
                if (element.length === 0) { // si il n'y as plus de boules afficher alors on affiche la suite 
                    this.generateFromLevel();
                    this.changeSunColor(sun);
                }
                raycaster.setFromCamera(this.mouse, camera);  //on recalcule le ray 
                intersects = raycaster.intersectObjects(this.scene.children);  //n'existe que pour changer la couleur des boules 
                if (intersects.length === 0) {
                    for (let j = 0; j < this.scene.children.length; j++) {
                        if (this.scene.children[j].type !== "DirectionalLight") {
                            vide = true;
                        }
                    }
                }
                else {
                    for (let i = 0; i < intersects.length; i++) {  //regarde pour chaque objet si on est dessus
                        if (vide) {
                            if (intersects[0].object.name !== "sun") {
                                this.changeColor(intersects[0].object);
                                vide = false;
                            }
                        }
                    }
                }
                renderer.render(this.scene, camera); // on render 
            }
            controls.update(); // on update le controller 
        }
        animate();//on se rappel pour continuer a tourner 
    }

    render() {
        return (
            <div ref={ref => (this.mount = ref)} >
                <Hud score={this.state.score} vie={this.state.vie}></Hud>
                <Message message={this.state.message} display={this.state.display} display2={this.state.display2} score={this.state.score}></Message>
            </div>
        )
    }
}